var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoldPodium = function SvgGoldPodium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 112,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#goldPodium_svg__a)",
    d: "M0 4a4 4 0 0 1 4-4h108a4 4 0 0 1 4 4v14H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#goldPodium_svg__b)",
    d: "M0 18h116v112H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m47.601 54.644 7.832-4.444h5.412v25.696h5.808V81H48.877v-5.104h6.556V55.92l-5.06 2.904z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldPodium_svg__a",
    x1: 60.544,
    x2: 60.544,
    y1: 0,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE28A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldPodium_svg__b",
    x1: 34.596,
    x2: 47.44,
    y1: 28.053,
    y2: 103.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C6AA6"
  })))));
};
export default SvgGoldPodium;